
<template>
  <div class="row text-left justify-content-center">
    <div class="col-12 col-md-10 col-xl-8">
      <h1 class="my-4">Test page</h1>
    </div>
  </div>
</template>
<style>
</style>
<script>
export default {
  name: 'TestPage',
  props: {
    app: Object
  },
  data: () => { return {

  }},
  computed: {

  },
  methods: {

  },
  components: {

  }
}
</script>
